import Model from './utils/model'

export default {
  ...Model,
  options: {
    translations: {
      name: 'Tâche'
    },
    name: 'task'
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/task.js